// Custom history/navigation utility for programmatic navigation
// Used to replace browserHistory from react-router v3 and push from react-router-redux
import { createBrowserHistory } from 'history'

// Create a single history instance to be shared across the app
export const history = createBrowserHistory()

// Navigation functions that mimic browserHistory API
export const browserHistory = {
  push: (path) => history.push(path),
  replace: (path) => history.replace(path),
  go: (n) => history.go(n),
  goBack: () => history.back(),
  goForward: () => history.forward(),
  listen: (listener) => history.listen(listener),
  get location() {
    return history.location
  }
}

// Redux action creator for navigation (replaces push from react-router-redux)
export const push = (path) => {
  return () => {
    history.push(path)
  }
}

export const replace = (path) => {
  return () => {
    history.replace(path)
  }
}

export default history
